var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgWarning = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.25, d: "M1.819 14.625 8.674 2.633a.377.377 0 0 1 .652 0l6.855 11.992a.376.376 0 0 1-.326.563H2.145a.376.376 0 0 1-.326-.563Z" }), _jsx("path", { fill: "currentColor", d: "M9 13.5A.75.75 0 1 0 9 12a.75.75 0 0 0 0 1.5" }), _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.25, d: "M9 6.75v4.125" })] }))); };
export default SvgWarning;
